import { ApiScope, MsalAuthService } from '@sew/auth-service';

export class AuthService extends MsalAuthService {
    private static instance: AuthService;

    private constructor(
        clientId: string,
        redirectUri: string,
        postLogoutRedirectUri: string,
        language: string,
        country: string,
        stage: string,
        apiScopes: ApiScope[],
        policy: string
    ) {
        super(clientId, redirectUri, postLogoutRedirectUri, language, country, stage, apiScopes, policy);
    }

    public static getInstance(
        clientId: string,
        redirectUri: string,
        postLogoutRedirectUri: string,
        language: string,
        country: string,
        stage: string,
        apiScopes: ApiScope[],
        policy: string
    ): AuthService {
        if (!AuthService.instance) {
            AuthService.instance = new AuthService(
                clientId,
                redirectUri,
                postLogoutRedirectUri,
                language,
                country,
                stage,
                apiScopes,
                policy
            );
        }
        return AuthService.instance;
    }
}
